module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main container one-column content"
  }, [_c('div', {
    staticClass: "col-main"
  }, [_c('div', {
    staticClass: "paypal_success"
  }, [_c('div', {
    staticClass: "page-title"
  }), _vm._v(" "), _c('h2', {
    staticClass: "sub-title"
  }, [_vm._v("\n                " + _vm._s(_vm.$t("message.thank_you_for_purchase")) + "\n                \n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(_vm.$t("message.your_order_is")) + "\n                : " + _vm._s(_vm.increment_id) + ".")]), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(_vm.$t("message.receive_an_confirm_email")) + "\n                \n            ")]), _vm._v(" "), _c('div', {
    staticClass: "buttons-set"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "type": "button",
      "title": "Continue Shopping"
    },
    on: {
      "click": function($event) {
        return _vm.redirectHome()
      }
    }
  }, [_c('span', [_c('span', [_vm._v("\n                            " + _vm._s(_vm.$t("message.continue_shopping")) + "\n                            \n                        ")])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-73b04650!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/body/payment/Success.vue
// module id = 259
// module chunks = 1